const $ = require('js/sw-jquery/sw-jquery');
const tracking = require('js/lib/tracking');

  //This helper file gives us methods that scrape relevant checkout flow data and format them for tracking.

  const formatObj = function(num, val, isMetric = false){
    let obj = {'value': val};
    let dimOrMetric = !isMetric ? 'dimension' : 'metric';
    obj[dimOrMetric] = num;
    return obj;
  };

  const cartOptionAndDimensionWrapper = function(){
    //Scraping relevant data from cart or confirm page via jQuery
    const selectedManufacturingOption = $('.manufacturing-radio:checked');
    const manufacturingSpeedOptionNum = selectedManufacturingOption.data('swUpdateService');
    const manufacturingSpeedOptionName = selectedManufacturingOption.next().html();
    const manufacturingSpeedPrice = selectedManufacturingOption.parent().find('[data-display-currency-component-value]').html();
    const shippingCountry = $('#country-selector option:selected').html();
    const selectedShippingOption = $('.shipping-option:checked');
    const shippingOptionNum = selectedShippingOption.val();
    const shippingOptionName = selectedShippingOption.data('swShippingOptionName');
    const shippingOptionPrice = selectedShippingOption.parent().find('[data-display-currency-component-value]').html();
    const promoCode = $('#discount-input').val();
    const orderProcessingFee = $('.processingFee').find('[data-display-currency-component-value]').html();

    //Adding the data we scraped from the page onto these two arrays with different expected input formats
    const manufacturingSpeedOption = 'Order Manufacturing Speed - ' + manufacturingSpeedOptionNum;
    const shippingOption = 'Order Shipping Method - ' + shippingOptionNum;
    const checkoutOptionValueArray = [manufacturingSpeedOption, shippingOption];

    const checkoutDimensionArray = [formatObj(9, manufacturingSpeedOptionName),
                                    formatObj(11, shippingOptionName)];
    const checkoutMetricArray = [formatObj(5, manufacturingSpeedPrice, true), formatObj(6, shippingOptionPrice, true)];

    if(shippingCountry){
      checkoutOptionValueArray.push('Order Shipping Country - ' + shippingCountry.trim());
      checkoutDimensionArray.push(formatObj(10, shippingCountry.trim()));
    }
    if(promoCode.length > 0){
      checkoutOptionValueArray.push('Order Promotion Code - ' + promoCode);
      checkoutDimensionArray.push(formatObj(6, promoCode));
    }
    if(orderProcessingFee > 0 ){
      checkoutMetricArray.push(formatObj(7, orderProcessingFee, true));
    }

    return {
      getCartOptionData(stepNum){
        return checkoutOptionValueArray.map(function(val){
          return {
            'ecommerce': tracking.getCheckoutOptionData(stepNum, val)
          };
        });
      },
      getCartDimensionData(){
        return checkoutDimensionArray;
      },
      getCartMetricData(){
        return checkoutMetricArray;
      }
    };
  };

  const loginSignupOptionAndDimensionWrapper = function(authMethod){
    //Scraping relevant data from checkout/shipping page via jQuery
    let optionData = [{'ecommerce': tracking.getCheckoutOptionData(2, 'Order Authentication Method - '+authMethod)}];
    let dimensionData = [formatObj(19, authMethod)];

    return {
      getLoginSignupOptionData(){
        return optionData;
      },
      getLoginSignupDimensionData(){
        return dimensionData;
      }
    };
  };

  const shippingOptionAndDimensionWrapper = function(){
    //Scraping relevant data from checkout/shipping page via jQuery
    const exclusiveOfferIsChecked =  $('#agreeNewsletter').is(':checked');
    let optionData = null;
    let dimensionData = null;
    if(exclusiveOfferIsChecked){
      optionData = [{'ecommerce': tracking.getCheckoutOptionData(3, 'Order Exclusive Offers Opt-In')}];
      dimensionData = [formatObj(16, 'Yes')];
    }
    return {
      getShippingOptionData(){
        return optionData;
      },
      getShippingDimensionData(){
        return dimensionData;
      }
    };
  };

  const billingOptionAndDimensionWrapper = function(){
    //Scraping relevant data from billing page via jQuery
    const selectedPaymentMethodName = $('[data-sw-billing-method-name]:checked').data('swBillingMethodName');
    return {
      getBillingOptionData(){
        const selectedPaymentMethod = 'Order Payment Method - ' + selectedPaymentMethodName;
        return [{'ecommerce': tracking.getCheckoutOptionData(4, selectedPaymentMethod)}];
      },
      getBillingDimensionData(){
        return [];
      }
    };
  };

module.exports = {
  cartOptionAndDimensionWrapper,
  loginSignupOptionAndDimensionWrapper,
  shippingOptionAndDimensionWrapper,
  billingOptionAndDimensionWrapper
};
